export const DEMO_CUSTOMER = {
  name: 'Demo Customer',
  email: 'demo@peek.com',
  phone: '+14155551234'
}
